// // // import React from "react";

// // // import { AppWrap } from "../../wrapper";
// // // import { MotionWrap } from "../../wrapper";

// // // import { images } from "../../constants";

// // // import "./Process.scss";

// // // type Approach = {
// // //   img: string;
// // //   title: string;
// // //   description: string;
// // //   phase: string;
// // // };

// // // const approachData: Approach[] = [
// // //   {
// // //     title: "Intake, Planning & Strategy",
// // //     description:
// // //       "Every successful project starts with clarity. Together, we define your goals, map out your audience, and outline key website / app features and designs, roadmap milestones, mentorship objectives, and pre-sales strategies. This isn’t just planning—it’s setting the stage for measurable results and meaningful learning experiences.",
// // //     img: images.processStep1a,
// // //     phase: "1",
// // //   },
// // //   {
// // //     title: "Build & Shape",
// // //     description:
// // //       "With the plan in place, we turn concepts into progress. Websites / apps take form, lesson structures come together, and mentorship frameworks start shaping, presales pitching materials get created. I keep you involved with updates, demos, feedback loops, and coaching insights—so you’re not just watching the process, you’re learning from it.",
// // //     img: images.processStep2,
// // //     phase: "2",
// // //   },
// // //   {
// // //     title: "Launch & Empower",
// // //     description:
// // //       "The moment it all comes together. Your website / app launches, educational content is polished, and mentorship or pre-sales materials are ready for action. Beyond delivery, I provide post-launch support to ensure you can manage, scale, and continue growing with confidence.",
// // //     img: images.processStep3,
// // //     phase: "3",
// // //   },
// // // ];

// // // const Process = () => {
// // //   return (
// // //     <>
// // //       <h2 className="head-text app__process-title">
// // //         My <span>Approach</span>
// // //       </h2>
// // //       <div className="app__process-container">
// // //         {approachData.map((approach) => (
// // //           <div className="app__process-item">
// // //             <div className="app__process-item-phase-container">
// // //               <h3>{approach.phase}</h3>
// // //             </div>
// // //             <div className="app__process-item-phase-title">
// // //               <h4>{approach.title}</h4>
// // //             </div>
// // //             <div className="app__process-item-phase-image">
// // //               <img src={approach.img} alt={approach.title} />
// // //             </div>
// // //             <div className="app__process-item-phase-text">
// // //               <p className="app__process-item-text">{approach.description}</p>
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default AppWrap(
// // //   MotionWrap(Process, "app__process"),
// // //   "process",
// // //   "app__whitebg"
// // // );

// // // import React from "react";
// // // import { AppWrap } from "../../wrapper";
// // // import { MotionWrap } from "../../wrapper";

// // // import { images } from "../../constants";

// // // import "./Process.scss";

// // // type Approach = {
// // //   img: string;
// // //   title: string;
// // //   description: string;
// // //   phase: string;
// // // };

// // // const approachData: Approach[] = [
// // //   {
// // //     title: "Intake, Planning & Strategy",
// // //     description:
// // //       "Every successful project starts with clarity. Together, we define your goals, map out your audience, and outline key website / app features and designs, roadmap milestones, mentorship objectives, and pre-sales strategies. This isn’t just planning—it’s setting the stage for measurable results and meaningful learning experiences.",
// // //     img: images.processStep1a,
// // //     phase: "1",
// // //   },
// // //   {
// // //     title: "Build & Shape",
// // //     description:
// // //       "With the plan in place, we turn concepts into progress. Websites / apps take form, lesson structures come together, and mentorship frameworks start shaping, presales pitching materials get created. I keep you involved with updates, demos, feedback loops, and coaching insights—so you’re not just watching the process, you’re learning from it.",
// // //     img: images.processStep2,
// // //     phase: "2",
// // //   },
// // //   {
// // //     title: "Launch & Empower",
// // //     description:
// // //       "The moment it all comes together. Your website / app launches, educational content is polished, and mentorship or pre-sales materials are ready for action. Beyond delivery, I provide post-launch support to ensure you can manage, scale, and continue growing with confidence.",
// // //     img: images.processStep3,
// // //     phase: "3",
// // //   },
// // // ];

// // // const Process = () => {
// // //   return (
// // //     <>
// // //       <h2 className="head-text app__process-title">
// // //         How I <span>Work</span>
// // //       </h2>
// // //       <div className="app__process-container">
// // //         {approachData.map((approach) => (
// // //           <div className="app__process-item" key={approach.phase}>
// // //             <div className="app__process-item-phase-container">
// // //               <h3>{approach.phase}</h3>
// // //             </div>
// // //             <div className="app__process-item-phase-image">
// // //               <img src={approach.img} alt={approach.title} />
// // //             </div>
// // //             <div className="app__process-item-phase-title">
// // //               <h4>{approach.title}</h4>
// // //             </div>
// // //             <div className="app__process-item-phase-text">
// // //               <p className="app__process-item-text">{approach.description}</p>
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </>
// // //   );
// // // };

// // // export default AppWrap(
// // //   MotionWrap(Process, "app__process"),
// // //   "process",
// // //   "app__whitebg",
// // // );

// // import React from "react";
// // import { AppWrap } from "../../wrapper";
// // import { MotionWrap } from "../../wrapper";

// // import { images } from "../../constants";

// // import "./Process.scss";

// // type Approach = {
// //   img: string;
// //   title: string;
// //   description: string;
// //   phase: string;
// // };

// // const approachData: Approach[] = [
// //   {
// //     title: "Discover & Plan",
// //     description:
// //       "We start by understanding your goals, audience, and challenges. Together, we define the project scope, key features, roadmap milestones, mentorship goals, and pre-sales strategies. Clarity upfront ensures measurable results and a strong foundation.",
// //     img: images.processStep1a,
// //     phase: "1",
// //   },
// //   {
// //     title: "Build & Iterate",
// //     description:
// //       "Ideas take shape into tangible outcomes—websites, apps, educational frameworks, or pre-sales materials. Through demos, feedback loops, and coaching, you stay involved and learn alongside the process, not just observe it.",
// //     img: images.processStep2,
// //     phase: "2",
// //   },
// //   {
// //     title: "Launch & Empower",
// //     description:
// //       "The project goes live! Websites, apps, or educational content are fully delivered. I provide post-launch guidance so you can manage, scale, and grow confidently, ensuring your success extends beyond delivery.",
// //     img: images.processStep3,
// //     phase: "3",
// //   },
// // ];

// // const Process = () => {
// //   return (
// //     <>
// //       <h2 className="head-text app__process-title">
// //         How I <span>Bring Ideas to Life</span>
// //       </h2>

// //       <div className="app__process-container">
// //         {approachData.map((approach) => (
// //           <div className="app__process-item" key={approach.phase}>
// //             <div className="app__process-item-phase-container">
// //               <h3>{approach.phase}</h3>
// //             </div>
// //             <div className="app__process-item-phase-title">
// //               <h4>{approach.title}</h4>
// //             </div>
// //             <div className="app__process-item-phase-image">
// //               <img src={approach.img} alt={approach.title} />
// //             </div>
// //             <div className="app__process-item-phase-text">
// //               <p className="app__process-item-text">{approach.description}</p>
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </>
// //   );
// // };

// // export default AppWrap(
// //   MotionWrap(Process, "app__process"),
// //   "process",
// //   "app__whitebg",
// // );

// import React from "react";

// import { AppWrap } from "../../wrapper";
// import { MotionWrap } from "../../wrapper";

// import { images } from "../../constants";

// import "./Process.scss";

// type Approach = {
//   img: string;
//   title: string;
//   description: string;
//   phase: string;
// };

// const approachData: Approach[] = [
//   {
//     title: "Plan with Purpose",
//     description:
//       "Clarity is everything. Together, we define goals, map your audience, outline features, and set mentorship or pre-sales objectives. This isn’t just planning—it’s creating a roadmap for success, measurable results, and meaningful learning.",
//     img: images.processStep1a,
//     phase: "1",
//   },
//   {
//     title: "Design, Develop & Learn",
//     description:
//       "We turn ideas into reality. Websites, apps, lessons, or mentorship frameworks take shape while you stay involved. Through demos, feedback, and coaching, you not only watch the process—you actively learn and contribute.",
//     img: images.processStep2,
//     phase: "2",
//   },
//   {
//     title: "Deliver & Grow",
//     description:
//       "Your project goes live with confidence. Websites, apps, and educational content are polished and ready. Post-launch, I provide support so you can manage, scale, and continue learning as you grow.",
//     img: images.processStep3,
//     phase: "3",
//   },
// ];

// const Process = () => {
//   return (
//     <>
//       <h2 className="head-text app__process-title">
//         <h2 className="head-text">Plan. Build. Empower.</h2>
//       </h2>

//       <div className="app__process-container">
//         {approachData.map((approach) => (
//           <div className="app__process-item" key={approach.phase}>
//             <div className="app__process-item-phase-container">
//               <h3>{approach.phase}</h3>
//             </div>
//             <div className="app__process-item-phase-title">
//               <h4>
//                 <span>{approach.title.split(" ")[0]}</span>{" "}
//                 {approach.title.split(" ").slice(1).join(" ")}
//               </h4>
//             </div>
//             <div className="app__process-item-phase-image">
//               <img src={approach.img} alt={approach.title} />
//             </div>
//             <div className="app__process-item-phase-text">
//               <p className="app__process-item-text">{approach.description}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(Process, "app__process"),
//   "process",
//   "app__whitebg",
// );

// import React from "react";
// import { motion } from "framer-motion";

// import { AppWrap } from "../../wrapper";
// import { MotionWrap } from "../../wrapper";

// import { images } from "../../constants";

// import "./Process.scss";

// interface Approach {
//   title: string;
//   description: string;
//   img: string;
//   phase: string;
// }

// const approachData: Approach[] = [
//   {
//     title: "Plan with Purpose",
//     description:
//       "Clarity is everything. Together, we define goals, map your audience, outline features, and set mentorship or pre-sales objectives. This isn’t just planning—it’s creating a roadmap for success, measurable results, and meaningful learning.",
//     img: images.processStep1a,
//     phase: "1",
//   },
//   {
//     title: "Build with Impact",
//     description:
//       "Bringing ideas to life with precision. We design, develop, and test digital products or educational solutions while ensuring they are scalable, accessible, and engaging for your audience.",
//     img: images.processStep2,
//     phase: "2",
//   },
//   {
//     title: "Empower for Growth",
//     description:
//       "Enabling teams and individuals to thrive. We train, mentor, and provide tools so your organization can continue to innovate, scale, and deliver value independently.",
//     img: images.processStep3,
//     phase: "3",
//   },
// ];

// // Words we want to highlight in descriptions
// const highlights = [
//   "goals",
//   "audience",
//   "features",
//   "success",
//   "results",
//   "learning",
//   "design",
//   "develop",
//   "test",
//   "scalable",
//   "accessible",
//   "engaging",
//   "train",
//   "mentor",
//   "innovate",
//   "scale",
//   "value",
// ];

// const highlightText = (text: string) => {
//   return text.split(" ").map((word, i) => {
//     const cleanWord = word.replace(/[.,]/g, "");
//     if (highlights.includes(cleanWord)) {
//       return (
//         <span key={i} className="text-purple">
//           {word}{" "}
//         </span>
//       );
//     }
//     return word + " ";
//   });
// };

// const Process = () => {
//   return (
//     <>
//       <h2 className="head-text app__process-title">
//         <span className="word">Plan</span>
//         <span className="dot">.</span>
//         <span className="word">Build</span>
//         <span className="dot">.</span>
//         <span className="word">Empower</span>
//         <span className="dot">.</span>
//       </h2>

//       <div className="app__process-container">
//         {approachData.map((approach) => (
//           <motion.div
//             key={approach.phase}
//             className="app__process-item"
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, ease: "easeOut" }}
//           >
//             <div className="app__process-item-phase-container">
//               <h3>{approach.phase}</h3>
//             </div>

//             <div className="app__process-item-phase-title">
//               <h4>
//                 {approach.title.split(" ").map((word, i) => (
//                   <span key={i} className="text-purple">
//                     {word}{" "}
//                   </span>
//                 ))}
//               </h4>
//             </div>

//             <div className="app__process-item-phase-image">
//               <img src={approach.img} alt={approach.title} />
//             </div>

//             <div className="app__process-item-phase-text">
//               <p className="app__process-item-text">
//                 {highlightText(approach.description)}
//               </p>
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(Process, "app__process"),
//   "process",
//   "app__whitebg",
// );

import React from "react";
import { motion } from "framer-motion";

import { AppWrap } from "../../wrapper";
import { MotionWrap } from "../../wrapper";

import { images } from "../../constants";

import "./Process.scss";

interface Approach {
  title: string;
  description: string;
  img: string;
  phase: string;
  highlights?: string[]; // words to highlight
}

// Highlight a string's words with <span className="text-purple"> if they match highlights
const highlightText = (text: string, highlights?: string[]) => {
  if (!highlights || highlights.length === 0) return text;

  // Split the text by spaces and wrap matches
  return text.split(" ").map((word, index) => {
    const cleanedWord = word.replace(/[.,]/g, ""); // remove punctuation for matching
    if (highlights.includes(cleanedWord)) {
      return (
        <span key={index} className="text-purple">
          {word}{" "}
        </span>
      );
    }
    return word + " ";
  });
};

const approachData: Approach[] = [
  {
    title: "Plan with Purpose",
    description:
      "Clarity is everything. Together, we define goals, map your audience, outline features, and set mentorship or pre-sales objectives. This isn’t just planning—it’s creating a roadmap for success, measurable results, and meaningful learning.",
    highlights: [
      "goals",
      "audience",
      "features",
      "success",
      "measurable",
      "learning",
    ],
    img: images.processStep1a,
    phase: "1",
  },
  {
    title: "Build with Impact",
    description:
      "Bringing ideas to life with precision. We design, develop, and test digital products or educational solutions while ensuring they are scalable, accessible, and engaging for your audience.",
    highlights: [
      "design",
      "develop",
      "test",
      "scalable",
      "accessible",
      "engaging",
    ],
    img: images.processStep2,
    phase: "2",
  },
  {
    title: "Empower for Growth",
    description:
      "Enabling teams and individuals to thrive. I'll train, mentor, and provide tools so your organization can continue to innovate, scale, and deliver value independently.",
    highlights: ["train", "mentor", "provide", "innovate", "scale", "deliver"],
    img: images.processStep3,
    phase: "3",
  },
];

const Process = () => {
  return (
    <>
      <h2 className="head-text app__process-title">
        <span className="word">Plan</span>
        <span className="dot">.</span>
        <span className="word">Build</span>
        <span className="dot">.</span>
        <span className="word">Empower</span>
        <span className="dot">.</span>
      </h2>

      <div className="app__process-container">
        {approachData.map((approach) => (
          <motion.div
            key={approach.phase}
            className="app__process-item"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="app__process-item-phase-container">
              <h3>{approach.phase}</h3>
            </div>

            <div className="app__process-item-phase-title">
              <h4>{highlightText(approach.title, approach.highlights)}</h4>
            </div>

            <div className="app__process-item-phase-image">
              <img src={approach.img} alt={approach.title} />
            </div>

            <div className="app__process-item-phase-text">
              <p className="app__process-item-text">
                {highlightText(approach.description, approach.highlights)}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Process, "app__process"),
  "process",
  "app__whitebg",
);
